import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NumberFormat from 'react-number-format';
import FailedFeedback from './FailedFeedback';

class NumberInputWithFeedback extends Component {
  render() {
    const { errorMessage } = this.props;

    let contentClass = '';
    let contentFeedback = '';

    if (errorMessage !== null) {
      if (errorMessage) {
        contentClass = 'has-error';
        contentFeedback = <FailedFeedback error={errorMessage} />;
      } else {
        contentClass = 'has-success';
        contentFeedback = (
          <span className={'form-control-feedback glyphicon glyphicon-ok'} />
        );
      }
    }

    return (
      <div className={`has-feedback ${contentClass}`}>
        <NumberFormat
          className="form-control"
          value={this.props.inputValue}
          onChange={this.props.onChangeValue}
          suffix={this.props.suffix}
          prefix={this.props.prefix}
          placeholder={this.props.placeholder}
          thousandSeparator="."
          decimalSeparator=","
          decimalPrecision={0}
          allowNegative={false}
          disabled={this.props.disabled}
        />
        {contentFeedback}
      </div>
    );
  }
}

NumberInputWithFeedback.propTypes = {
  inputValue: PropTypes.string,
  onChangeValue: PropTypes.func,
  suffix: PropTypes.string,
  prefix: PropTypes.string,
  placeholder: PropTypes.String,
  maximumDigit: PropTypes.number,
};

export default NumberInputWithFeedback;
